//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "AppGrid",
	props: ["item"],
	methods: {
		getDate(date) {
			//console.log('ListItem: ', date);
			var parts = (date ? date.split('T')[0].split('-') : null);
			if (!parts || parts.length < 3 || parts[0].length != 4 || parseInt(parts[0]) < 1900) return '';
			return [parts[1], parts[2], parts[0]].join('/');
		}
}
};
